import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';

/**
 * cart: {
 *      1234567: { // distibutor id
 *          name: '',
 *          currencySymbol: '',
 *          minimumOrder: 0,
 *          cart: [
 *              {
 *                  _id: '',
 *                  image: '',
 *                  SKU: '',
 *                  productNameENG: '',
 *                  rcp: '',
 *                  rsp: '',
 *                  minimumOrderQty: 0,
 *                  quantity: 0
 *              },
 *              }
 *          ],
 *      }
 * }
 */
const initialState = {
  cart: {}
};

const slice = createSlice({
  name: 'instock',
  initialState,
  reducers: {
    addCart(state, action) {
      const {
        product,
        distributorID,
        distributorName,
        quantity
      } = action.payload;

      const _product = {
        _id: product._id,
        image: product.coverImage,
        SKU: product.SKU,
        productNameENG: product.productNameENG,
        rcp: product.rcp,
        rsp: product.rsp,
        minimumOrderQty: product?.minimumOrderQty,
        discount: product.discount,
        quantity: quantity
      };

      const isDistributorExisted = state.cart.hasOwnProperty(distributorID);

      if (isDistributorExisted) {
        const isProductExisted = state.cart[distributorID].cart.some(
          (item) => item._id === _product._id
        );

        if (isProductExisted) {
          state.cart[distributorID].cart = map(
            state.cart[distributorID].cart,
            (item) => {
              if (item._id === _product._id) {
                return {
                  ...item,
                  quantity: item.quantity + quantity
                };
              }
              return item;
            }
          );
        } else {
          state.cart[distributorID].cart.push(_product);
        }
      } else {
        state.cart[distributorID] = {
          name: distributorName,
          currencySymbol: product.currencySymbol,
          minimumOrder: product.minimumOrder,
          cart: [_product]
        };
      }
    },

    updateCart(state, action) {
      const { cart } = action.payload;

      state.cart = cart;
    },

    deleteCart(state, action) {
      const { distributorID, productID } = action.payload;

      state.cart[distributorID].cart = filter(
        state.cart[distributorID].cart,
        (item) => {
          return item._id !== productID;
        }
      );

      if (state.cart[distributorID].cart.length === 0) {
        delete state.cart[distributorID];
      }
    },

    onChangeQuantity(state, action) {
      const { distributorID, productID, quantity } = action.payload;

      state.cart[distributorID].cart = map(
        state.cart[distributorID].cart,
        (item) => {
          if (item._id === productID) {
            return {
              ...item,
              quantity
            };
          }
          return item;
        }
      );
    },

    increaseQuantity(state, action) {
      const { distributorID, productID } = action.payload;

      state.cart[distributorID].cart = map(
        state.cart[distributorID].cart,
        (item) => {
          if (item._id === productID) {
            return {
              ...item,
              quantity: item.quantity + 1
            };
          }
          return item;
        }
      );
    },

    decreaseQuantity(state, action) {
      const { distributorID, productID } = action.payload;

      state.cart[distributorID].cart = map(
        state.cart[distributorID].cart,
        (item) => {
          if (item._id === productID) {
            return {
              ...item,
              quantity: item.quantity - 1
            };
          }
          return item;
        }
      );
    },

    removeProductsFromCart(state, action) {
      const { distributorID, products } = action.payload;

      const productIds = products.map((item) => item._id);

      state.cart[distributorID].cart = filter(
        state.cart[distributorID].cart,
        (item) => !productIds.includes(item._id)
      );

      if (state.cart[distributorID].cart.length === 0) {
        delete state.cart[distributorID];
      }
    },

    resetCart(state) {
      state.cart = {};
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addCart,
  updateCart,
  deleteCart,
  onChangeQuantity,
  increaseQuantity,
  decreaseQuantity,
  removeProductsFromCart,
  resetCart
} = slice.actions;
